// some responsive stuff
jQuery(document).ready(function ($) {

    /*
        1. NAV FUNCTIONALITY
        2. LEARNING AND DEVELOPMENT CAROUSEL
        3. YOUTUBE IFRAME RESPONSIVENESS
        4. EVENT SEARCH FILTERS FOR MOBILE
        5. TABS ON IE8
        6. HOMEPAGE PODS TABLET BREAKPOINT
        7. PERSISTENT TAB ACCORDION HASH FUNCTIONALITY
    */


    /* 1. NAV FUNCTIONALITY
    ------------------------------------------*/
    $('.nav-toggle').bind('click', function (event) {
        $('.primary-nav').toggleClass('full');
        //$('#nav .nav').attr("tabindex", "-1");
        event.preventDefault();
    });


    $('nav .expand').bind('click', function (event) {

        var showClass = 'showing';
        var expandBtn = $(this);
        var targetSubmenu = $(this).parent().find('ul.sub-menu');
        var subMenus = $('ul.sub-menu.showing');

        if (targetSubmenu.hasClass(showClass)) {
            expandBtn.removeClass(showClass);
            return targetSubmenu.removeClass(showClass).slideUp();
        }

        $('nav .expand').removeClass(showClass);
        expandBtn.addClass(showClass);
        subMenus.removeClass(showClass).slideToggle();
        targetSubmenu.addClass(showClass).slideToggle();
        event.preventDefault();

    });

    /* 2. LEARNING AND DEVELOPMENT CAROUSEL
    ------------------------------------------*/
    (function ($) {

        if (!$('.roundabout').length) return;

        // The carousel container.
        var roundabout = $('.carousel-learn-dev .roundabout');

        // Options for the slick carousel.
        var opts = {
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 3,
            dots: true,
            useTransform: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        };

        roundabout.on('init', function () {
            roundabout.each(function () {

                // Equalise the heights of the roundabout slideshow.
                var matchHeight = roundabout.find('.slide-body').matchHeight({ byRow: false });

                // On resize, update the slides heights, already a default throttle on update function.
                $(window).resize(matchHeight._update);
            });
        });

        // Initialise slick on roundabout.
        roundabout.slick(opts);

        //Call to action for item in focus.
        roundabout.find('.slick-slide').click(function () {
            if (($(this).hasClass('slick-center')) || ($(this).hasClass('slick-current'))) {
                window.location = $(this).attr('rel');
            }
        });

    })(jQuery);

    /* 3. RESPONSIVE YOUTUBE VIDEOS IN IFRAME
    ------------------------------------------*/
    // Find all YouTube videos
    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap('<div class="video-container" />');


    /* 4. EVENT SEARCH FILTERS FOR MOBILE
    ------------------------------------------*/
    $('.filter-toggle').bind('click', function (event) {
        $('.events-filter').toggleClass('show');
        $(this).text(($(this).text() == 'Hide filters') ? 'Show filters' : 'Hide filters');
        event.preventDefault();
    });

    /* 5. TABS ON IE8
    ------------------------------------------*/
    if ($('.ie8').length) {
        if ($('ul.tabs').length) {
            //tab - click event handler
            $(this).find('li a').click(function (e) {
                var which = $(this).attr('href');
                $('.is-active').removeClass('is-active');
                $(which).addClass('is-active');
                $(this).parent('li').addClass('is-active');
                e.preventDefault();
            });
        }
    }

    /* 6. HOMEPAGE PODS TABLET BREAKPOINT
    ------------------------------------------*/
    if ($('.homepage').length) {
        
        var breakpoints = { min: 624, max: 1006 };

        function equalPodHeight() {

            var windowWidth = $(window).width();

            if (windowWidth >= breakpoints.min && windowWidth <= breakpoints.max) {

                $('.pod').matchHeight({ property: 'min-height' });

            }

        }

        $(window).resize(equalPodHeight);

        equalPodHeight();

    }

    $('[data-match-height]').matchHeight({ property: 'min-height' });

    /* 7. PERSISTENT TAB ACCORDION HASH FUNCTIONALITY
    -----------------------------------------------------*/
    if ($('ul.tabs').length) {

        var hash = window.location.hash;

        if (hash !== '') {

            $('[data-tabs] a[href="' + hash + '"]').trigger('click');

        }

        if ($('.guides-resources').length) {

            setTimeout(function () {

                var $guidesResources = $('.guides-resources');

                if ($guidesResources.length) {
                    $guidesResources.css({ 'opacity': 1 });
                }

            }, 250);

        }

    }

    /* 21. TAB LIST ACCORDION  
------------------------------------------*/
    $('.tab-list--item a').on('click', function (e) {
        e.preventDefault();
        var container = $(this).closest('.tab-component');

        container.find('.tab-list--item.active').removeClass('active');
        $(this).parent('li').addClass('active');

        var tabItem = $(this).attr('data-tab');
        var panelItem = container.find(".tab-list--content").find("[data-panel='" + tabItem + "']");
        container.find('.tab-list--panel.active').removeClass('active');
        panelItem.addClass('active');
    });

    if ($('.tab-list').length) {
        $('.tab-list').each(function () {
            $(this).find('.tab-list--item').first().find('a').click();
        });
    }

    /* 21.1 TAB LIST ACCORDION - HASH CHECKING
------------------------------------------*/
    $(document).ready(function () {
        if (window.location.hash) {
            // only do this if there's a tab-list on the page, otherwise do the usual anchor behaviour
            if ($('.tab-list').length) {
                var hash = decodeURIComponent(window.location.hash.substr(1));
                var tabNumber = hash.slice(-1) - 1;
                $(".tab-list .tab-list--item:eq(" + tabNumber + ")").find('a').click();

                var $container = $("html,body");
                var $scrollTo = $('.tab-list');

                window.location.hash = '';

                $container.animate({ scrollTop: $scrollTo.offset().top - 100 - $container.offset().top + $container.scrollTop(), scrollLeft: 0 }, 300);

            }
        }
    });

    /* 21.2 TAB LIST ACCORDION - ON PAGE LINKS
------------------------------------------*/
    $(document).ready(function () {
        $('.js-tab-link').on('click', function () {
            //console.group('click');
            var hash = this.hash;
            //console.group(hash);
            var tabNumber = hash.slice(-1) - 1;
            //console.groupEnd(tabNumber);
            $(".tab-list .tab-list--item:eq(" + tabNumber + ")").find('a').click();

            var $container = $("html,body");
            var $scrollTo = $('.tab-list');

            $container.animate({ scrollTop: $scrollTo.offset().top - 100 - $container.offset().top + $container.scrollTop(), scrollLeft: 0 }, 300);
        });
    });


});